import React, { Component, Suspense } from 'react'
import { BrowserRouter, HashRouter, Route, Routes } from 'react-router-dom'
import './scss/style.scss'
import UserAgreement from './views/pages/user-agreement/UserAgreement';
import OGAAppLogin from './views/pages/oga-app-login-screen/OGAAppLogin';
import OGAAppRegister from './views/pages/oga-app-register-screen/OGAAppRegister';
import SecureMeLogin from './views/pages/secureme-login-screen/SecureMeLogin';
import LandingPage from './views/pages/landing-page/LandingPage';

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse" />
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <Suspense fallback={loading}>
          <Routes>
            <Route exact path="/login" name="Login Page" element={<Login />} />
            <Route exact path="/register" name="Register Page" element={<Register />} />
            <Route exact path="/user-authentication" name="User Agreement Page" element={<UserAgreement />} />
            <Route exact path="/oga-app" name="OgaApp Login Page" element={<OGAAppLogin />} />
            <Route exact path="/oga-app/register" name="OgaApp Create Account Page" element={<OGAAppRegister />} />
            <Route exact path="/registration" name="OgaApp Registration Page" element={<OGAAppRegister />} />
            <Route exact path="/secureme-app" name="SecureMe Login Page" element={<SecureMeLogin />} />
            <Route exact path="/" name="landing Page" element={<LandingPage />} />
            <Route exact path="/404" name="Page 404" element={<Page404 />} />
            <Route exact path="/500" name="Page 500" element={<Page500 />} />
            <Route path="*" name="Home" element={<DefaultLayout />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    )
  }
}

export default App
